const e = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
    <path fill="currentColor" fill-rule="evenodd"
        d="M4.0238 1.085C5.00432 1.15605 6.02603 1.63403 7.00407 2.60139C7.98187 1.6343 9.00267 1.15723 9.9823 1.08776C11.0879 1.00934 12.0653 1.4562 12.7725 2.16121C14.1628 3.54735 14.5994 6.05556 12.8742 7.78081C12.8684 7.78663 12.8624 7.7923 12.8563 7.79783L7.33974 12.7947C7.14923 12.9673 6.85891 12.9673 6.6684 12.7947L1.15183 7.79783C1.14573 7.7923 1.13976 7.78663 1.13394 7.78081C-0.600286 6.04658 -0.166014 3.53807 1.22889 2.153C1.93778 1.44911 2.91716 1.00482 4.0238 1.085Z"
        clip-rule="evenodd"></path>
</svg>`;
export {
  e as default
};
